/* =========================================================
   GLOW & GRACE — ANIMATION ENGINE
   ========================================================= */

document.addEventListener("DOMContentLoaded", () => {

  const revealElements = document.querySelectorAll(
    ".gg-reveal, .gg-reveal-left, .gg-reveal-right"
  );

  if (!revealElements.length) return;

  const observer = new IntersectionObserver(
    (entries, observer) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          entry.target.classList.add("gg-visible");

          observer.unobserve(entry.target);

        }

      });

    },
    {
      threshold: 0.12,
      rootMargin: "0px 0px -60px 0px"
    }
  );

  revealElements.forEach((element) => {
    observer.observe(element);
  });

});